import React, { useEffect, useRef, useState } from "react";
import { getCustomerPicture } from "../../../api/schedulingApi";

export default function CustomerAvatar({ customer, botId, className = "h-10 w-10" }) {
  const [url, setUrl] = useState(customer?.profile_picture_url || "");
  const [failed, setFailed] = useState(false);
  const refreshed = useRef(false);
  const generation = useRef(0);
  useEffect(() => {
    generation.current += 1;
    setUrl(customer?.profile_picture_url || "");
    setFailed(false);
    refreshed.current = false;
    return () => { generation.current += 1; };
  }, [customer?.id, customer?.profile_picture_url, botId]);
  const imageFailed = async () => {
    setUrl("");
    if (refreshed.current || !botId || !customer?.profile_picture_file_id) {
      setFailed(true);
      return;
    }
    refreshed.current = true;
    const current = generation.current;
    try {
      const picture = await getCustomerPicture(botId, customer.id);
      if (current !== generation.current) return;
      setUrl(picture.profile_picture_url || "");
      setFailed(!picture.profile_picture_url);
    } catch {
      if (current === generation.current) setFailed(true);
    }
  };
  const name = customer?.name || "Customer";
  const initials = name.trim().split(/\s+/).slice(0, 2).map((part) => part[0]).join("").toUpperCase();
  return <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-cyan-50 text-sm font-semibold text-cyan-800 ${className}`}
    title={failed ? "Profile picture unavailable. Reload customer details to retry." : undefined}>
    {url ? <img src={url} alt={`${name} profile`} loading="lazy" referrerPolicy="no-referrer" className="h-full w-full object-cover"
      onLoad={() => { refreshed.current = false; }} onError={imageFailed} />
      : <span aria-label={`${name} initials`}>{initials}</span>}
  </span>;
}
